import type { ReactNode } from 'react';

import { FieldLabel } from './FieldLabel';

export interface InlineFieldLabelProps {
  /** Id ovládacího prvku (propojí `<label for>`); volitelné, když label cílí přes vnoření. */
  htmlFor?: string;
  children: ReactNode;
  required?: boolean;
  disabled?: boolean;
  /** Šířka levého sloupce labelu v px. */
  width: number;
}

/**
 * Levý sloupec inline (tabulkového) labelu — jediné sdílené místo pro inline labely napříč
 * `TextBox`, `AsyncSelector` i `Field`. Pevná šířka (`width`) a vertikální zarovnání na střed první
 * řádky ovládacího prvku (výška `--phx-control`), aby label opticky seděl na vstupu, ne nad ním.
 */
export function InlineFieldLabel({
  htmlFor,
  children,
  required,
  disabled,
  width,
}: InlineFieldLabelProps) {
  return (
    <div
      className="min-h-phx-control flex shrink-0 items-center"
      style={{ flex: `0 0 ${width}px` }}
    >
      <FieldLabel htmlFor={htmlFor} required={required} disabled={disabled}>
        {children}
      </FieldLabel>
    </div>
  );
}
